<template>
  <div
    class="relative bg-cover bg-center"
    :class="[
      styles.containerClass,
      $style.backgroundImage,
      backgroundImageClass,
    ]"
  >
    <!-- overlay -->
    <div
      v-if="styles.hasOverlay && displayOverlay"
      class="absolute"
      :class="[styles.overlayClass, overlayClass]"
    />

    <div
      class="text-static-default-hi relative flex flex-col items-center justify-center"
      :class="[styles.moodClass, containerClass]"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { tw } from '@backmarket/utils/string/tw'
import { useIllustrationOptimizer } from '@ds/plugin'

import type { BackgroundProps } from './Background.types'
import { getBackgroundStyles } from './Background.utils'

const {
  background,
  rounded,
  containerClass,
  customOverlayClass,
  customBackgroundImageClass,
  displayOverlay = true,
} = defineProps<
  BackgroundProps & {
    containerClass?: string
    customOverlayClass?: string
    customBackgroundImageClass?: string
    displayOverlay?: boolean
  }
>()

const styles = computed(() => getBackgroundStyles({ background, rounded }))

const overlayClass = computed(() => {
  if (customOverlayClass) return customOverlayClass

  return tw`bg-surface-default-low bottom-0 left-0 right-0 top-0 opacity-40`
})

const backgroundImageClass = computed(() => {
  if (customBackgroundImageClass) return customBackgroundImageClass

  return tw`bg-cover bg-center`
})

const mobileBackgroundURL = `url(${useIllustrationOptimizer(() => styles.value.backgroundImage.mobile || '').value.src})`
const desktopBackgroundURL = `url(${useIllustrationOptimizer(() => styles.value.backgroundImage.desktop || '').value.src})`
</script>

<style module>
.backgroundImage {
  background-image: v-bind(mobileBackgroundURL);

  @media (min-width: theme('screens.md')) {
    background-image: v-bind(desktopBackgroundURL);
  }
}
</style>
